import { createFileRoute } from '@tanstack/react-router';
import Journeys from '@/pages/journeys';
import { JourneysSegmentImportHandoff, type SegmentImportUrlStep } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

const STEPS = ['map', 'review', 'preprocessing', 'validating', 'importing'] as const;

function asStep(value: string): Exclude<SegmentImportUrlStep, 'new' | 'setup'> | null {
  return STEPS.find((step) => step === value) ?? null;
}

/**
 * A step of a segment import's wizard, which forwards to the imports wizard.
 * A step name the wizard does not have stays with the embedded app, which decides what it means.
 */
function JourneysSegmentImportStepRoute() {
  const { segmentId, importId, step } = Route.useParams();
  const known = asStep(step);

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      {known == null ? (
        <Journeys />
      ) : (
        <JourneysSegmentImportHandoff segmentId={segmentId} importId={importId} step={known} />
      )}
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/$step',
)({
  component: JourneysSegmentImportStepRoute,
});
